module.exports = __webpack_public_path__ + "media/images/patient-icons/inventory-icon-9d785922b44611f6d49b3b1a495b4042.svg";